export const theme = {
  breakpoints: { sm: '375px', md: '768px', lg: '1024px', xl: '1280px', '2xl': '1440px', base: '0px', xxl: '1440px' },
  colors: {
    'accent-default': '#AFDFFFFF',
    'accent-hover': '#C8E9FFFF',
    'accent-pressed': '#96D5FFFF',
    'accent-disabled': '#D5DCE1FF',
    'accent-focus': '#5CD8FFFF',
    'primary-default': '#183344FF',
    'primary-hover': '#295977FF',
    'primary-pressed': '#0F2736FF',
    'primary-disabled': '#8E9DA6FF',
    'primary-focus': '#AFDFFFFF',
    'secondary-default': '#38749DFF',
    'secondary-hover': '#4C87AFFF',
    'secondary-pressed': '#2B5F82FF',
    'secondary-disabled': '#9CB1BFFF',
    'secondary-focus': '#00A5ECFF',
    'alert-error-default': '#FF9473FF',
    'alert-error-hover': '#F14A2FFF',
    'alert-error-pressed': '#C31B00FF',
    'alert-error-disabled': '#FFCCC3FF',
    'alert-error-focus': '#FFD5CEFF',
    'alert-warning-default': '#F5E695FF',
    'alert-warning-hover': '#FFA932FF',
    'alert-warning-pressed': '#E88700FF',
    'alert-warning-disabled': '#E3AD61FF',
    'alert-success-default': '#7CF1C7FF',
    'alert-success-hover': '#1CC661FF',
    'alert-success-pressed': '#168845FF',
    'alert-success-disabled': '#6DA785FF',
    'alert-inform-default': '#1F78D1FF',
    'alert-inform-hover': '#2793FFFF',
    'alert-inform-pressed': '#1861ABFF',
    'alert-inform-disabled': '#8CB0D3FF',
    'background-light': '#FFFFFFFF',
    'background-dark': '#1B1B1BFF',
    'background-card': '#FFFFFFFF',
    'background-page': '#F7F4ECFF',
    'background-page-01': '#F1D5C2FF',
    'background-page-02': '#FF9473FF',
    'background-page-03': '#F2ECDBFF',
    'background-page-04': '#797979FF',
    'background-page-05': '#424242FF',
    'background-overlay': '#183344BF',
    'background-static': '#AFC2CFFF',
    'background-container-default': '#FFFFFFFF',
    'background-container-hover': '#FFFCF5FF',
    'background-container-pressed': '#F1ECE1FF',
    'background-container-disabled': '#E0E0E0FF',
    'background-container-active': '#D5D5EBFF',
    'background-action-default': '#FDFDFFFF',
    'background-action-hover': '#FCFAF1FF',
    'background-action-pressed': '#F4F0E3FF',
    'background-action-disabled': '#EAEAEAFF',
    'background-action-active': '#D2EDFFFF',
    'background-skeleton-start': '#E2E8F0FF',
    'background-skeleton-end': '#EDF2F7FF',
    'background-text-highlight': '#AFDFFFFF',
    'background-error': '#FFDDD8FF',
    'background-warning': '#FFF5BEFF',
    'background-success': '#DEFFEBFF',
    'background-inform': '#E4F2FFFF',
    'text-light': '#FFFFFFFF',
    'text-primary': '#183344FF',
    'text-primary-negative': '#FFFFFFFF',
    'text-secondary': '#5B5B5BFF',
    'text-secondary-negative': '#D6D6D6FF',
    'text-disabled': '#B0B0B0FF',
    'text-disabled-negative': '#767676FF',
    'text-button-accent': '#0E1D27FF',
    'text-button-primary': '#FFFFFFFF',
    'text-button-secondary': '#0E1D27FF',
    'text-button-alert': '#183344FF',
    'text-button-transparent': '#0E1D27FF',
    'text-badge-solid': '#FFFFFFFF',
    'text-badge-outline': '#4F4FFFFF',
    'text-badge-subtle': '#4F4FFFFF',
    'text-link-accent-default': '#AFDFFFFF',
    'text-link-accent-hover': '#C8E9FFFF',
    'text-link-accent-pressed': '#96D5FFFF',
    'text-link-primary-default': '#183344FF',
    'text-link-primary-hover': '#295977FF',
    'text-link-primary-pressed': '#0F2736FF',
    'text-link-secondary-default': '#38749DFF',
    'text-link-secondary-hover': '#4C87AFFF',
    'text-link-secondary-pressed': '#2B5F82FF',
    'text-success': '#136D38FF',
    'text-warning': '#705800FF',
    'text-error': '#6C0505FF',
    'ui-element-divider': '#D4C2B5FF',
    'ui-element-outline-default': '#A9A69FFF',
    'ui-element-outline-active': '#0086DBFF',
    'ui-element-outline-disabled': '#F2F2F2FF',
    'text-link-light-default': '#D6D6D6FF',
    'text-link-light-hover': '#EFEFEFFF',
    'text-link-light-pressed': '#AFDFFFFF',
    'text-link-light-disabled': '#656565FF',
    'graph-app-01': '#7EF1C7FF',
    'graph-app-02': '#8CEBAFFF',
    'graph-app-03': '#9CE398FF',
    'graph-app-04': '#ADDB84FF',
    'graph-app-05': '#BED174FF',
    'graph-app-06': '#CFC769FF',
    'graph-app-07': '#DEBB63FF',
    'graph-app-08': '#ECAF64FF',
    'graph-app-09': '#F7A26AFF',
    'graph-app-10': '#FF9575FF',
    'graph-lp-02': '#183344FF',
    'graph-lp-03': '#295977FF',
    'graph-lp-04': '#38749DFF',
    'graph-lp-05': '#9CB1BFFF',
    'graph-lp-06': '#96D5FFFF',
    'graph-lp-07': '#C8E9FFFF',
    'graph-lp-08': '#FF9473FF',
    'graph-lp-09': '#F1D5C2FF',
    'graph-lp-01': '#0E1D27FF',
    'gradient-01': 'linear-gradient(90.00deg, #204660 0.00%, #0E1D27 100.00%)',
    'gradient-02': 'linear-gradient(90.00deg, #0E1D27 0.00%, #204660 100.00%)',
    'gradient-03': 'linear-gradient(90.00deg, #7CF1C7 0.00%, #FF9473 64.58%)',
    'gradient-04': 'linear-gradient(90.00deg, #38749D 0.00%, #FF9473 100.00%)',
  },
  space: {
    'spacer-0': '0rem',
    'spacer-px': '0.062rem',
    'spacer-half': '0.125rem',
    'spacer-1': '0.250rem',
    'spacer-2': '0.500rem',
    'spacer-3': '0.750rem',
    'spacer-4': '1.000rem',
    'spacer-5': '1.250rem',
    'spacer-6': '1.500rem',
    'spacer-7': '1.750rem',
    'spacer-8': '2.000rem',
    'spacer-9': '2.250rem',
    'spacer-10': '2.500rem',
    'spacer-12': '3.000rem',
    'spacer-14': '3.500rem',
    'spacer-16': '4.000rem',
    'spacer-20': '5.000rem',
    'spacer-24': '6.000rem',
    'spacer-28': '7.000rem',
    'spacer-32': '8.000rem',
    'spacer-36': '9.000rem',
    'spacer-40': '10.000rem',
    'spacer-44': '11.000rem',
    'spacer-48': '12.000rem',
    'spacer-52': '13.000rem',
    'spacer-56': '14.000rem',
    'spacer-60': '15.000rem',
    'spacer-64': '16.000rem',
    'spacer-72': '18.000rem',
    'spacer-80': '20.000rem',
    'spacer-86': '24.000rem',
  },
  radii: {
    'radii-half': '0.125rem',
    'radii-1': '0.250rem',
    'radii-2': '0.375rem',
    'radii-3': '0.500rem',
    'radii-4': '0.750rem',
    'radii-5': '1.000rem',
    'radii-6': '1.500rem',
    'radii-card': '0.500rem',
    'radii-modal': '0.500rem',
    'radii-alertdialog': '0.500rem',
    'radii-popover': '0.375rem',
    'radii-button': '624.938rem',
  },
  shadows: {
    'elevation-default': '0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
    'elevation-interactive': '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
    'elevation-modals': '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
    'elevation-outline': '0px 0px 0px 3px rgba(194, 194, 255, 0.3)',
    'elevation-inner': 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06)',
  },
  textStyles: {
    'text-header-4XL': {
      color: 'text-primary',
      fontSize: { lg: '3.125rem', base: '2.500rem' },
      fontWeight: 400,
      letterSpacing: '0rem',
      lineHeight: { lg: '4.500rem', base: '3.375rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-4xl-v': {
      color: 'text-primary',
      fontSize: { lg: '3.125rem', base: '2.500rem' },
      fontWeight: 400,
      letterSpacing: '0.062rem',
      lineHeight: { lg: '4.500rem', base: '3.375rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-3XL': {
      color: 'text-primary',
      fontSize: { lg: '2.750rem', base: '2.250rem' },
      fontWeight: 400,
      letterSpacing: { lg: '0.019rem', base: '0rem' },
      lineHeight: { lg: '3.500rem', base: '3.000rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-3xl-v': {
      color: 'text-primary',
      fontSize: { lg: '2.750rem', base: '2.250rem' },
      fontWeight: 400,
      letterSpacing: '0.062rem',
      lineHeight: { lg: '3.500rem', base: '3.000rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-2XL': {
      color: 'text-primary',
      fontSize: { lg: '2.500rem', base: '2.000rem' },
      fontWeight: 400,
      letterSpacing: { lg: '0.013rem', base: '0rem' },
      lineHeight: { lg: '3.500rem', base: '2.875rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-2xl-v': {
      color: 'text-primary',
      fontSize: { lg: '2.500rem', base: '2.000rem' },
      fontWeight: 400,
      letterSpacing: '0.062rem',
      lineHeight: { lg: '3.500rem', base: '2.875rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-XL': {
      color: 'text-primary',
      fontSize: { lg: '2.250rem', base: '1.750rem' },
      fontWeight: 400,
      letterSpacing: { lg: '0.013rem', base: '0rem' },
      lineHeight: { lg: '2.625rem', base: '2.125rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-xl-v': {
      color: 'text-primary',
      fontSize: { lg: '2.250rem', base: '1.750rem' },
      fontWeight: 400,
      letterSpacing: '0.062rem',
      lineHeight: { lg: '2.625rem', base: '2.125rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-L': {
      color: 'text-primary',
      fontSize: { lg: '1.875rem', base: '1.375rem' },
      fontWeight: 400,
      letterSpacing: { lg: '0.013rem', base: '0rem' },
      lineHeight: { lg: '2.500rem', base: '1.875rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-l-v': {
      color: 'text-primary',
      fontSize: { lg: '1.875rem', base: '1.375rem' },
      fontWeight: 400,
      letterSpacing: { lg: '0.031rem', base: '0.062rem' },
      lineHeight: { lg: '2.500rem', base: '1.875rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-M': {
      color: 'text-primary',
      fontSize: { lg: '1.500rem', base: '1.250rem' },
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: { lg: '2.375rem', base: '1.750rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-m-v': {
      color: 'text-primary',
      fontSize: { lg: '1.500rem', base: '1.250rem' },
      fontWeight: 400,
      letterSpacing: { lg: '0.031rem', base: '0.062rem' },
      lineHeight: { lg: '2.375rem', base: '1.750rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-S': {
      color: 'text-primary',
      fontSize: '1.125rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: { lg: '1.500rem', base: '1.750rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-s-v': {
      color: 'text-primary',
      fontSize: '1.125rem',
      fontWeight: 400,
      letterSpacing: '0.062rem',
      lineHeight: { lg: '1.500rem', base: '1.750rem' },
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-header-XS': {
      color: 'text-primary',
      fontSize: { lg: '1.000rem', base: '0.875rem' },
      fontWeight: 500,
      letterSpacing: { lg: '0.125rem', base: '0.094rem' },
      lineHeight: { lg: '1.250rem', base: '1.125rem' },
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-header-xs-v': {
      color: 'text-primary',
      fontSize: '0.875rem',
      fontWeight: 400,
      letterSpacing: '0.094rem',
      lineHeight: '1.250rem',
      textDecoration: 'none',
      fontFamily: 'Libre Baskerville',
      fontStyle: 'italic',
    },
    'text-body-display-2XL': {
      color: 'text-primary',
      fontSize: '3.125rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '4.125rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-display-XL': {
      color: 'text-primary',
      fontSize: '2.750rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '3.625rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-display-L': {
      color: 'text-primary',
      fontSize: '2.250rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '3.000rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-display-M': {
      color: 'text-primary',
      fontSize: '2.000rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '2.750rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-display-S': {
      color: 'text-primary',
      fontSize: '1.500rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '2.125rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-display-XS': {
      color: 'text-primary',
      fontSize: '1.250rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.750rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-large-regular': {
      color: 'text-primary',
      fontSize: '1.125rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '1.625rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-large-medium': {
      color: 'text-primary',
      fontSize: '1.125rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.625rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-large-bold': {
      color: 'text-primary',
      fontSize: '1.125rem',
      fontWeight: 700,
      letterSpacing: '0.013rem',
      lineHeight: '1.625rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-regular': {
      color: 'text-primary',
      fontSize: '1.000rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '1.500rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-medium': {
      color: 'text-primary',
      fontSize: '1.000rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.500rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-bold': {
      color: 'text-primary',
      fontSize: '1.000rem',
      fontWeight: 700,
      letterSpacing: '0.013rem',
      lineHeight: '1.500rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-meta-regular': {
      color: 'text-primary',
      fontSize: '0.875rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '1.250rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-meta-medium': {
      color: 'text-primary',
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.250rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-floating-label-regular': {
      color: 'text-primary',
      fontSize: '0.750rem',
      fontWeight: 400,
      letterSpacing: '0.013rem',
      lineHeight: '1.125rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-floating-label-medium': {
      color: 'text-primary',
      fontSize: '0.750rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.125rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-floating-label-bold': {
      color: 'text-primary',
      fontSize: '0.750rem',
      fontWeight: 700,
      letterSpacing: '0.013rem',
      lineHeight: '1.125rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-body-meta-bold': {
      color: 'text-primary',
      fontSize: '0.875rem',
      fontWeight: 700,
      letterSpacing: '0.013rem',
      lineHeight: '1.250rem',
      textDecoration: 'none',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-link-body-large': {
      color: 'text-link-accent-default',
      fontSize: '1.125rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.625rem',
      textDecoration: 'underline',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-link-body-medium': {
      color: 'text-link-accent-default',
      fontSize: '1.000rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.500rem',
      textDecoration: 'underline',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
    'text-link-body-small': {
      color: 'text-link-accent-default',
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.013rem',
      lineHeight: '1.250rem',
      textDecoration: 'underline',
      fontFamily: 'Inter',
      fontStyle: 'normal',
    },
  },
  components: {
    TextPairing: {
      parts: ['label', 'subLabel', 'container'],
      variants: {
        'textpairing-header-4XL': {
          label: { variant: 'text-header-4XL' },
          subLabel: { variant: { md: 'text-body-display-S', base: 'text-body-display-XS' } },
          container: { gap: { md: '1.000rem', base: '1.250rem' } },
        },
        'textpairing-header-3XL': {
          label: { variant: 'text-header-3XL' },
          subLabel: { variant: { md: 'text-body-display-S', base: 'text-body-display-XS' } },
          container: { gap: '1.000rem' },
        },
        'textpairing-header-2XL': {
          label: { variant: 'text-header-2XL' },
          subLabel: { variant: { md: 'text-body-display-S', base: 'text-body-display-XS' } },
          container: { gap: { md: '1.000rem', base: '0.750rem' } },
        },
        'textpairing-header-M': {
          label: { variant: 'text-header-M' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-header-S': {
          label: { variant: 'text-header-S' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-header-L': {
          label: { variant: 'text-header-L' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: { md: '0.500rem', base: '0.250rem' } },
        },
        'textpairing-header-XL': {
          label: { variant: 'text-header-XL' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: '0.500rem' },
        },
        'textpairing-body-display-2XL': {
          label: { variant: 'text-body-display-2XL' },
          subLabel: { variant: 'text-body-large-regular' },
          container: { gap: '1.000rem' },
        },
        'textpairing-body-display-XL': {
          label: { variant: 'text-body-display-XL' },
          subLabel: { variant: 'text-body-large-regular' },
          container: { gap: '0.750rem' },
        },
        'textpairing-body-display-L': {
          label: { variant: 'text-body-display-L' },
          subLabel: { variant: 'text-body-large-regular' },
          container: { gap: '0.750rem' },
        },
        'textpairing-body-display-M': {
          label: { variant: 'text-body-display-M' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: '0.500rem' },
        },
        'textpairing-body-display-S': {
          label: { variant: 'text-body-display-S' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: '0.500rem' },
        },
        'textpairing-body-bold': {
          label: { variant: 'text-body-bold' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-body-bold-meta': {
          label: { variant: 'text-body-bold' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-body-meta-bold': {
          label: { variant: 'text-body-meta-bold' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.125rem' },
        },
        'textpairing-body-medium': {
          label: { variant: 'text-body-medium' },
          subLabel: { variant: 'text-body-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-body-regular-meta': {
          label: { variant: 'text-body-regular' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-body-medium-meta': {
          label: { variant: 'text-body-medium' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.250rem' },
        },
        'textpairing-body-meta-medium': {
          label: { variant: 'text-body-meta-medium' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.125rem' },
        },
        'textpairing-body-meta-regular': {
          label: { variant: 'text-body-meta-regular' },
          subLabel: { variant: 'text-body-meta-regular' },
          container: { gap: '0.125rem' },
        },
      },
    },
  },
};
